import React, { useState } from 'react';

import {isMobile} from "react-device-detect";

import './index.scss';

export default function SwipeDetector(props) {
  const {onSwipeLeft, onSwipeRight, ignore, disabled} = props;
  // topLimiter
  // onSwipeUp, onSwipeDown, 

  const [touchStart, setTouchStart] = useState({ x: 0, y: 0 });
  const [touchEnd, setTouchEnd] = useState({ x: 0, y: 0 });

  // Minimum distance required to consider it a swipe
  const minSwipeDistance = 20; 

  const scale = window.devicePixelRatio || 1;

  const handleTouchStart = (e) => {
    let ignoredBlock
    ignore.map(className => {
      console.log(className, Boolean(e.target.closest(className)), e)
      if (e.target.closest(className)) ignoredBlock = Boolean(e.target.closest(className))
    })

    if (!ignoredBlock) {
      setTouchEnd({ x: 0, y: 0 }); // Reset end touch state
      setTouchStart({
        x: e.targetTouches[0].clientX / scale,
        y: e.targetTouches[0].clientY / scale
      });
    }
  };

  const handleTouchMove = (e) => {
    let ignoredBlock
    ignore.map(className => {
      console.log(className, Boolean(e.target.closest(className)), e)
      if (e.target.closest(className)) ignoredBlock = Boolean(e.target.closest(className))
    })

    if (!ignoredBlock) {
      setTouchEnd({
        x: e.targetTouches[0].clientX / scale,
        y: e.targetTouches[0].clientY / scale
      });
    }
  };

  const handleTouchEnd = () => {
    if (disabled && disabled()) return;
    if (!touchStart.x || !touchEnd.x) return;

    const distanceX = touchStart.x - touchEnd.x;
    const distanceY = touchStart.y - touchEnd.y;
    const isHorizontalSwipe = Math.abs(distanceX) > Math.abs(distanceY);

    //  && (topLimiter ? (touchStart.y > topLimiter) : true)
    if (isHorizontalSwipe) {
      if (Math.abs(distanceX) > minSwipeDistance) {
        if (distanceX > 0) {
          if (onSwipeRight) onSwipeRight()
        } else {
          if (onSwipeLeft) onSwipeLeft()
        }
      }
    }
    // else {
    //   if (Math.abs(distanceY) > minSwipeDistance) {
    //     if (distanceY > 0) {
    //       if (onSwipeUp) onSwipeUp()
    //     } else {
    //       if (onSwipeDown) onSwipeDown()
    //     }
    //   }
    // }
  };

  if (!isMobile) return props.children

  return (
    <div
      className='SwipeDetector'
      onTouchStart={handleTouchStart} 
      onTouchMove={handleTouchMove} 
      onTouchEnd={handleTouchEnd}
    >
      {props.children}
    </div>
  );
}
